import { Link } from "react-router-dom";
import { useEffect, useRef } from "react";
import gsap from "gsap";

const NotFoundPage = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    gsap.fromTo(
      containerRef.current,
      { opacity: 0, y: 40 },
      { opacity: 1, y: 0, duration: 0.7, ease: "power2.out" }
    );
  }, []);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4">
      <div ref={containerRef} className="text-center w-full max-w-md">
        <h1 className="text-8xl font-extrabold mb-6 text-black tracking-tight select-none">
          404
        </h1>
        <p className="text-2xl mb-10 text-black font-medium select-none">
          Page not found
        </p>
        <Link
          to="/"
          className="inline-block px-8 py-3 border-2 border-black text-black font-semibold rounded-full transition-transform duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2"
        >
          Go Home
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
